import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { ForgotpasswordSuccessComponent } from './forgotpassword-success.component';

@NgModule({
  declarations: [
    ForgotpasswordSuccessComponent
  ],
  imports: [
    CommonModule,
    MatCardModule
  ],
  exports: [
    ForgotpasswordSuccessComponent
  ],
})
export class ForgotpasswordSuccessModule { }